/** Maximum number of messages retained in communication panels */
export const MAX_MESSAGES = 1000;
